import { useEffect } from 'react';
import { useAppDispatch } from 'src/store/hooks';
import { handleModalAccountVerified } from 'src/store/actions/modal';
import Image from '../reusable/Image';
import { Paragraph } from '../reusable/Typography';
import * as SVG from 'src/assets/icons';

const CheckEmailPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    setTimeout(() => {
      dispatch(handleModalAccountVerified(true));
    }, 4000);
  });

  return (
    <div className="relative h-[calc(100vh-650px)] container mx-auto flex justify-center">
      <div className="absolute top-1/2 transform translate-y-1/2 max-w-md">
        <div className=" flex justify-center mb-10">
          <div className="relative bg-[#E8F1FF] rounded-full p-8">
            <Image src={SVG.MailGiftCard} />
            <Image
              className="absolute top-8 right-10"
              src={SVG.GreenEllipseGiftCard}
            />
          </div>
        </div>
        <div className="text-center">
          <Paragraph>
            An email has been sent to{' '}
            <span className="font-bold">name@email.com</span>.
          </Paragraph>
          <Paragraph>
            Click the link in the mail to verify your account
          </Paragraph>
        </div>
      </div>
    </div>
  );
};

export default CheckEmailPage;
